import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
import { QrCodeIcon, CreditCardIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function SmartIdRfid() {
  const [activeTab, setActiveTab] = useState<'cards' | 'issue' | 'verify'>('cards');
  const [currentStep, setCurrentStep] = useState(0);
  const [verificationResult, setVerificationResult] = useState<'valid' | 'invalid' | null>(null);
  const cards = [{
    cardId: 'CARD-2024-001',
    name: 'Rahim Uddin',
    nid: '1234567890123',
    type: 'QR + RFID',
    issueDate: '2024-01-15',
    expiry: '2025-01-15',
    status: 'active' as const
  }, {
    cardId: 'CARD-2024-002',
    name: 'Karim Sheikh',
    nid: '2345678901234',
    type: 'QR Code',
    issueDate: '2024-02-10',
    expiry: '2025-02-10',
    status: 'active' as const
  }, {
    cardId: 'CARD-2024-003',
    name: 'Fatema Begum',
    nid: '3456789012345',
    type: 'RFID',
    issueDate: '2024-02-20',
    expiry: '2025-02-20',
    status: 'active' as const
  }, {
    cardId: 'CARD-2024-004',
    name: 'Abdul Hakim',
    nid: '4567890123456',
    type: 'QR + RFID',
    issueDate: '2023-12-01',
    expiry: '2024-12-01',
    status: 'expired' as const
  }, {
    cardId: 'CARD-2024-005',
    name: 'Jamal Hossain',
    nid: '5678901234567',
    type: 'QR Code',
    issueDate: '2024-01-20',
    expiry: '2024-03-15',
    status: 'lost' as const
  }];
  const columns = [{
    key: 'cardId',
    label: 'Card ID'
  }, {
    key: 'name',
    label: 'Beneficiary Name'
  }, {
    key: 'nid',
    label: 'NID'
  }, {
    key: 'type',
    label: 'Card Type'
  }, {
    key: 'issueDate',
    label: 'Issue Date'
  }, {
    key: 'expiry',
    label: 'Expiry'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-1881" />
  }];
  const filters = [{
    key: 'type',
    label: 'Card Type',
    options: ['QR Code', 'RFID', 'QR + RFID']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Active', 'Expired', 'Lost', 'Replaced']
  }];
  const wizardSteps = [{
    title: 'Select Beneficiary',
    description: 'Choose approved beneficiary'
  }, {
    title: 'Card Configuration',
    description: 'Configure card type and settings'
  }, {
    title: 'Review & Print',
    description: 'Review and print the card'
  }];
  return <div className="space-y-6" data-id="element-1882">
      <div data-id="element-1883">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1884">Smart ID & RFID</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1885">
          Manage smart ID cards and RFID verification
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-1886">
        <div className="flex gap-4" data-id="element-1887">
          <button onClick={() => setActiveTab('cards')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'cards' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1888">
            Card Management
          </button>
          <button onClick={() => setActiveTab('issue')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'issue' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1889">
            Issue New Card
          </button>
          <button onClick={() => setActiveTab('verify')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'verify' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1890">
            Verification
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'cards' && <DataTable columns={columns} data={cards} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} searchPlaceholder="Search cards..." data-id="element-1891" />}

      {activeTab === 'issue' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      alert('Card issued successfully!');
      setCurrentStep(0);
      setActiveTab('cards');
    }} data-id="element-1892">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1893">
              <div data-id="element-1894">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1895">
                  Search Approved Beneficiary *
                </label>
                <input type="text" placeholder="Enter NID or Name" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1896" />
              </div>
              <div className="bg-gray-50 rounded-lg p-4 border border-gray-200" data-id="element-1897">
                <div className="flex items-center gap-4" data-id="element-1898">
                  <div className="w-16 h-16 bg-gray-300 rounded-full flex items-center justify-center text-2xl" data-id="element-1899">
                    👤
                  </div>
                  <div className="flex-1" data-id="element-1900">
                    <h4 className="font-semibold text-gray-900" data-id="element-1901">Rahim Uddin</h4>
                    <div className="text-sm text-gray-600 mt-1" data-id="element-1902">
                      <div data-id="element-1903">NID: 1234567890123</div>
                      <div data-id="element-1904">Profession: Jele (Fisher)</div>
                      <div data-id="element-1905">
                        Status: <StatusBadge status="approved" data-id="element-1906" />
                      </div>
                    </div>
                  </div>
                  <button className="px-4 py-2 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32]" data-id="element-1907">
                    Select
                  </button>
                </div>
              </div>
            </div>}
          {currentStep === 1 && <div className="space-y-4" data-id="element-1908">
              <div data-id="element-1909">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1910">
                  Card Type *
                </label>
                <div className="grid grid-cols-1 max-w-xs" data-id="element-1911">
                  <label className="border-2 border-[#1B5E20] bg-green-50 rounded-lg p-4 cursor-pointer" data-id="element-1912">
                    <input type="radio" name="cardType" value="rfid" className="sr-only" defaultChecked data-id="element-1913" />
                    <div className="text-center" data-id="element-1914">
                      <CreditCardIcon className="mx-auto mb-2 text-[#1B5E20]" size={32} data-id="element-1915" />
                      <div className="font-medium" data-id="element-1916">RFID</div>
                    </div>
                  </label>
                </div>
              </div>
              <div className="bg-gray-100 rounded-lg p-6 border-2 border-dashed border-gray-300" data-id="element-1917">
                <div className="text-center text-gray-600" data-id="element-1918">
                  <div className="text-sm font-medium mb-2" data-id="element-1919">
                    Card Template Preview
                  </div>
                  <div className="bg-white rounded-lg p-4 inline-block" data-id="element-1920">
                    <div className="w-64 h-40 border-2 border-gray-300 rounded-lg flex items-center justify-center" data-id="element-1921">
                      <div className="text-center" data-id="element-1922">
                        <div className="font-bold text-lg mb-2" data-id="element-1923">
                          Bangladesh Forest Dept.
                        </div>
                        <div className="text-sm" data-id="element-1924">Rahim Uddin</div>
                        <div className="text-xs text-gray-600 mt-1" data-id="element-1925">
                          ID: CARD-2024-XXX
                        </div>
                        <div className="mt-3 w-20 h-20 bg-gray-200 mx-auto" data-id="element-1926"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>}
          {currentStep === 2 && <div className="space-y-6" data-id="element-1927">
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-1928">
                <h4 className="font-semibold text-gray-900 mb-4" data-id="element-1929">
                  Card Preview
                </h4>
                <div className="space-y-6" data-id="element-1930">
                  {/* Front Side */}
                  <div data-id="element-1931">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-1932">
                      Front Side
                    </p>
                    <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 max-w-2xl mx-auto" data-id="element-1933">
                      <img src="https://cdn.magicpatterns.com/uploads/pqj4eXKmV692dt1h5NizSK/image.png" alt="Smart ID Card - Front" className="w-full h-auto object-contain" data-id="element-1934" />
                    </div>
                  </div>
                  {/* Back Side */}
                  <div data-id="element-1935">
                    <p className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-1936">
                      Back Side
                    </p>
                    <div className="rounded-xl overflow-hidden shadow-lg border border-gray-200 max-w-2xl mx-auto" data-id="element-1937">
                      <img src="https://cdn.magicpatterns.com/uploads/3k2tX1SLhegMkNKt1LT53X/BackCard(1).png" alt="Smart ID Card - Back" className="w-full h-auto object-contain" data-id="element-1938" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-center" data-id="element-1939">
                <button className="px-6 py-3 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] font-medium" data-id="element-1940">
                  Print Card
                </button>
              </div>
            </div>}
        </WizardForm>}

      {activeTab === 'verify' && <div className="max-w-2xl mx-auto" data-id="element-1941">
          <div className="bg-white rounded-lg border border-gray-200 p-8" data-id="element-1942">
            <h3 className="text-xl font-semibold text-gray-900 text-center mb-6" data-id="element-1943">
              Verify Smart ID Card
            </h3>

            <div className="space-y-4 mb-8" data-id="element-1944">
              <button onClick={() => setVerificationResult('valid')} className="w-full flex items-center justify-center gap-3 px-6 py-4 bg-[#1B5E20] text-white rounded-lg hover:bg-[#2E7D32] transition-colors" data-id="element-1945">
                <QrCodeIcon size={24} data-id="element-1946" />
                <span className="font-medium" data-id="element-1947">Scan QR Code</span>
              </button>

              <div className="text-center text-sm text-gray-600" data-id="element-1948">OR</div>

              <input type="text" placeholder="Enter Card ID manually" className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1949" />

              <div className="text-center text-sm text-gray-600" data-id="element-1950">OR</div>

              <button onClick={() => setVerificationResult('invalid')} className="w-full flex items-center justify-center gap-3 px-6 py-4 border-2 border-[#1B5E20] text-[#1B5E20] rounded-lg hover:bg-green-50 transition-colors" data-id="element-1951">
                <CreditCardIcon size={24} data-id="element-1952" />
                <span className="font-medium" data-id="element-1953">Tap RFID Card</span>
              </button>
            </div>

            {verificationResult && <div className={`rounded-lg p-6 ${verificationResult === 'valid' ? 'bg-green-50 border-2 border-green-500' : 'bg-red-50 border-2 border-red-500'}`} data-id="element-1954">
                <div className="flex items-start gap-4" data-id="element-1955">
                  {verificationResult === 'valid' ? <CheckCircleIcon className="text-green-600 flex-shrink-0" size={48} data-id="element-1956" /> : <XCircleIcon className="text-red-600 flex-shrink-0" size={48} data-id="element-1957" />}
                  <div className="flex-1" data-id="element-1958">
                    <h4 className={`text-xl font-bold mb-2 ${verificationResult === 'valid' ? 'text-green-900' : 'text-red-900'}`} data-id="element-1959">
                      {verificationResult === 'valid' ? 'Valid Card' : 'Invalid Card'}
                    </h4>
                    {verificationResult === 'valid' ? <div className="space-y-2 text-sm text-green-900" data-id="element-1960">
                        <div data-id="element-1961">
                          <span className="font-semibold" data-id="element-1962">Name:</span> Rahim
                          Uddin
                        </div>
                        <div data-id="element-1963">
                          <span className="font-semibold" data-id="element-1964">Card ID:</span>{' '}
                          CARD-2024-001
                        </div>
                        <div data-id="element-1965">
                          <span className="font-semibold" data-id="element-1966">Profession:</span>{' '}
                          Jele (Fisher)
                        </div>
                        <div data-id="element-1967">
                          <span className="font-semibold" data-id="element-1968">Active Permit:</span>{' '}
                          PER-2024-001 (Fishing, Valid until 2024-04-05)
                        </div>
                        <div data-id="element-1969">
                          <span className="font-semibold" data-id="element-1970">Status:</span>{' '}
                          <StatusBadge status="active" data-id="element-1971" />
                        </div>
                      </div> : <div className="text-sm text-red-900" data-id="element-1972">
                        <div className="font-semibold mb-1" data-id="element-1973">
                          Reason: Card Expired
                        </div>
                        <div data-id="element-1974">
                          This card expired on 2024-03-15. Please renew the card
                          before entry.
                        </div>
                      </div>}
                  </div>
                </div>
              </div>}
          </div>
        </div>}
    </div>;
}